import React from 'react';
import {HanzHeaderContainer} from "../common/HanzHeaderContainer";

export function HomeService() {
    return (<HanzHeaderContainer title="Professional Services" buttonText="" buttonPath="">
        <strong>Technical Program Committee:</strong>
            <ul>
                <li>IEEE International Symposium on Hardware Oriented Security and Trust
                    (<em>HOST</em>) 2027
                </li>
                <li>ACM/IEEE International Conference on Codesign of Embedded Systems
                    (<em>CODES</em>) 2026
                </li>
                <li>IEEE International Symposium on Hardware Oriented Security and Trust
                    (<em>HOST</em>) 2026
                </li>
                <li>ACM/IEEE International Conference on Hardware/Software Codesign and System Synthesis
                    (<em>CODES+ISSS</em>) 2025
                </li>
            </ul>
            <strong>Artifacts Evaluation Committee:</strong>
            <ul>
                <li>IEEE/ACM International Symposium on Microarchitecture®
                    (<em>MICRO</em>) 2026
                </li>
                <li>ACM/IEEE International Conference on Codesign of Embedded Systems
                    (<em>CODES</em>) 2026
                </li>
                <li>ACM/IEEE International Conference on Hardware/Software Codesign and System Synthesis
                    (<em>CODES+ISSS</em>) 2025
                </li>
            </ul>
            <strong>Reviewer:</strong>
            <ul>
                <li>IEEE Journal on Selected Areas in Communications, 2025, 2026</li>
                <li>ACM Computing Surveys, 2025 </li>
                <li>IEEE Transactions on Computers, 2025 </li>
                <li>Design, Automation, and Test in Europe (<em>DATE</em>), 2024 and 2025</li>
                <li>IEEE International Symposium on Hardware Oriented Security and Trust (<em>HOST</em>), 2023, 2024, and 2025
            </li>
            <li>ACM/IEEE International Conference on Hardware/Software Codesign and System Synthesis
                (<em>CODES+ISSS</em>), 2022, 2023, and 2025
            </li>
            <li>International Multidisciplinary Engineering Research Conference (<em>MERCon</em>), 2022, 2025</li>
            <li>Engineering Research Unit (<em>ERU</em>) Symposium by University of Moratuwa, 2024</li>
            <li>IESL Young Members’ Section Technical Conference, 2021</li>
        </ul>
            <strong>Judge:</strong>
            <ul><li>North Carolina Postdoc Research Symposium by UNC, 2026</li></ul>

    </HanzHeaderContainer>
);
}
